/* TODO: t() */
import React, { Component, Children } from 'react';
import { View, StyleSheet } from 'react-native';

import { Text } from '../../../uiold';
import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';
import { Addon } from '../../../../types/shared/Addon';
import formatCurrency from '../../../../core/support/formatCurrency';

type Props = {
  hideLabel?: boolean;
  isRequired?: boolean;
  definition: FormFieldDefinition;
  children?: React.ReactNode | null | undefined;
  addons?: Map<string, Addon> | null | undefined;
};

class FormField extends Component<Props> {
  render() {
    let {
      hideLabel,
      isRequired,
      children,
      definition: formDef,
      addons,
      ...otherProps
    } = this.props;
    let definition: ObjectOf<unknown> = this.props.definition;
    let addonId = formDef.type === 'AddonElement' ? formDef.id : undefined;
    let addon = addons && addonId ? addons.get(addonId) : undefined;
    if (Children.count(children) === 0) {
      return null;
    }
    if (definition.type === 'HeadingElement') {
      return <View>{children}</View>;
    }
    let labelText =
      typeof definition.label === 'string' ? definition.label.trim() : null;
    let label;
    if (labelText && !hideLabel) {
      let separator = labelText.match(/[:.?]$/) ? '' : ':';
      labelText += separator;
      let caption = null;
      if (definition.hidden) {
        caption = ' (hidden)';
      } else if (
        definition.is_required ||
        isRequired ||
        definition.require_acceptance
      ) {
        if (
          definition.type !== 'MultichoiceElement' ||
          definition.allow_multi
        ) {
          caption = ' (required)';
        }
      }

      label = (
        <View style={styles.labelDiv}>
          <Text style={styles.labelText}>
            {addon
              ? `${labelText} (${formatCurrency(addon.defaultPrice)} per day)`
              : `${labelText}`}
          </Text>
          {caption && <Text style={styles.captionText}>{caption}</Text>}
        </View>
      );
    }

    let accessibilityRole =
      definition.type === 'TextElement' || definition.type === 'LocationInput'
        ? ('label' as const)
        : undefined;

    return (
      <View
        style={styles.fieldCard}
        accessibilityRole={accessibilityRole}
        {...otherProps}
      >
        {label}
        {children}
      </View>
    );
  }
}

let styles = StyleSheet.create({
  fieldCard: {
    paddingHorizontal: 30,
    paddingVertical: 10,
  },
  labelText: {
    fontWeight: 'normal',
  },
  labelDiv: {
    flexDirection: 'row',
    marginBottom: 2,
  },
  captionText: {
    color: 'grey',
    fontWeight: 'normal',
    fontStyle: 'italic',
  },
});

export default FormField;
